import { render, staticRenderFns } from "./ditchList.vue?vue&type=template&id=f4c7809a&scoped=true&"
import script from "./ditchList.vue?vue&type=script&lang=js&"
export * from "./ditchList.vue?vue&type=script&lang=js&"
import style0 from "./ditchList.vue?vue&type=style&index=0&id=f4c7809a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c7809a",
  null
  
)

export default component.exports